import { render } from "./SecondCallPage.vue?vue&type=template&id=36b0684a&scoped=true"
import script from "./SecondCallPage.vue?vue&type=script&lang=js"
export * from "./SecondCallPage.vue?vue&type=script&lang=js"

import "./SecondCallPage.vue?vue&type=style&index=0&id=36b0684a&lang=scss&scoped=true"

import exportComponent from "/home/forge/vienaiespeja.on-forge.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b0684a"]])

export default __exports__